import Time from "../../../../components/Time";
import React from "react";

type RetroHuntTooltipInfoProps = {
  title: string;
  labels?: {
    start: string;
    finish: string;
  };
  startTime?: string | null;
  endTime?: string | null;
};

const RetroHuntTooltipInfo = ({
  title,
  labels = { start: "Started", finish: "Finished" },
  startTime,
  endTime
}: RetroHuntTooltipInfoProps) => (
  <div>
    <div>{title}</div>
    <div>
      {labels.start}: {startTime ? <Time time={startTime} /> : "--"}
    </div>
    <div>
      {labels.finish}: {endTime ? <Time time={endTime} /> : "Unknown"}
    </div>
  </div>
);

export default RetroHuntTooltipInfo;
